import React, { Fragment } from 'react';
import s from './style.module.css';

type CourseInterviewCardProps = {
    id: number;
    image: string;
    title: string;
    memberName: string;
    work: string;
    courses: Array<{ id: number; name: string }>;
};

export const CourseInterviewCard = (props: CourseInterviewCardProps) => {
    return (
        <div className={s.course_interview_card}>
            <div className={s.image}>
                <img src={props.image} />
            </div>
            <div className={s.info}>
                <h4>{props.title}</h4>
                <p className={s.name}>{props.memberName}様</p>
                <div className={s.courses}>
                    {props.courses.map((c, i) => (
                        <Fragment key={c.id}>
                            <a href={`/courses/${c.id}`}>{c.name}</a>
                            {i !== props.courses.length - 1 ? <span>/</span> : ''}
                        </Fragment>
                    ))}
                </div>
                <p className={s.work}>{props.work}</p>
                <p className={s.link}>
                    <a href={`/course_interviews/${props.id}`}>詳細を見る&gt;</a>
                </p>
            </div>
        </div>
    );
};

export default CourseInterviewCard;
